import { toggleUnenrollModal } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast, showSuccessToast } from "utils/toast";
import {
  patientApi,
  useUpdatePatientMutation,
} from "app/store/patient/api/patientApi";
import { PATIENT_DEACTIVATE_REASONS } from "static/constants";

const UnenrollPatientModal = () => {
  const dispatch = useDispatch();
  const { showUnenrollModal, patient } = useSelector(
    (state) => state.nonCompliantPatient
  );

  const [updatePatient, { isLoading }] = useUpdatePatientMutation();
  const reason = PATIENT_DEACTIVATE_REASONS?.[6];

  const handleConfirm = async (active) => {
    try {
      const response = await updatePatient({
        patientId: patient?._id,
        payload: {
          active,
          deactivate_reason: reason,
        },
      }).unwrap();
      if (!response?.error) {
        showSuccessToast(response?.message);
        dispatch(patientApi.util.invalidateTags(["nonCompliantPatients"]));
      }
    } catch (error) {
      showErrorToast(error?.message);
    } finally {
      dispatch(toggleUnenrollModal({ showModal: false }));
    }
  };

  return (
    <ConfirmModal
      show={showUnenrollModal}
      title="Confirm Patient Deactivation?"
      showContentDivider
      confirmButtonProps={{
        color: "error",
      }}
      confirmText="Deactivate"
      isConfirming={isLoading}
      onCancel={() => dispatch(toggleUnenrollModal({ showModal: false }))}
      onConfirm={() => handleConfirm(false)}
      cancelButtonProps={{
        style: {
          borderColor: "#969696",
          color: "#969696",
        },
      }}
    >
      <div className="mt-2">
        Are you sure you want to deactivate <b>{patient?.name}</b>? Doing this
        will deactivate their account with reason as <b>{reason}</b>.
      </div>
    </ConfirmModal>
  );
};

export default UnenrollPatientModal;
